export default "__VITE_ASSET__$zq0CbRe__"